import axios from "../http"; // 导入axios实例
import qs from "qs"; // 根据需求是否导入qs模块

const getOrder ={
    getOrderLists(params) {
        return axios.post(`/mobile/page/pc_order_lists`,qs.stringify(params));
    },
    getOrderDetail(params) {
        return axios.post(`/mobile/page/detail`,qs.stringify(params));
    },
    //取消支付
    cancel_pay(params) {
        return axios.post(`/mobile/page/close_order`, qs.stringify(params));
    },
    //查看物流
    getMail(params) {
        return axios.post(`/mobile/page/mail`, qs.stringify(params));
    },
    //申请退货
    getApplication(params) {
        return axios.post(`/mobile/page/application`, qs.stringify(params));
    },
    setOrderRefund(params) {
        return axios.post(`/mobile/page/order_refund_save`, qs.stringify(params));
    },
    setOrderMail(params) {
        return axios.post(`/mobile/page/pc_mail`, qs.stringify(params));
    },
    closeOrderCancel(params) {
        return axios.post(`/mobile/page/cancel_return`,qs.stringify(params));
    },
    getPinjia(params) {
        return axios.post(`/mobile/page/pc_saveadd`,qs.stringify(params));
    },
    getInfo(params) {
        return axios.post(`mobile/page/pl_only_index`,qs.stringify(params));
    },
    subPayOrder(params) {
        return axios.post(`mobile/page/pay`,qs.stringify(params));
    },
    //支付宝支付
    subZfbPayOrder(params) {
        return axios.post(`mobile/page/zfb_pay_order`,qs.stringify(params));
    },
    //微信支付
    subWxPayOrder(params) {
        return axios.post(`mobile/page/wx_pay_order`,qs.stringify(params));
    },
    //确认收货
    getConfirm(params) {
        return axios.post(`mobile/page/confirm`,qs.stringify(params));
    },
    getPayOrder(params) {
        return axios.post(`/mobile/page/pay_lists`, qs.stringify(params));
    },
    setOrder(params) {
        return axios.post(`/mobile/page/save`, qs.stringify(params));
    },
    setMstjOrder(params) {
        return axios.post(`/mobile/page/mstj_save`, qs.stringify(params));
    },
    IsSuccessOrder(params) {
        return axios.post(`/mobile/page/pay_success`, qs.stringify(params));
    },
    is_turntable(params) {
        return axios.post(`/mobile/page/ask`, qs.stringify(params));
    },
    getPayOrderInfo(params) {
        return axios.post(`/mobile/page/pay_order_info`, qs.stringify(params));
    },
    //获取订单信息
    getRechangePayOrderInfo(params) {
        return axios.post(`/mobile/page/getRechangePayOrderInfo`, qs.stringify(params));
    },
    //支付宝充值支付
    subZfbRechangePayOrder(params) {
        return axios.post(`mobile/page/zfb_rechange_pay_order`,qs.stringify(params));
    },
    //获取充值支付列表
    getRechangeList(params) {
        return axios.post(`mobile/page/get_rechange_list`,qs.stringify(params));
    },
    //获取充值支付列表
    getOrderList(params) {
        return axios.post(`mobile/page/get_order_list`,qs.stringify(params));
    },
    changePayPassword(params) {
        return axios.post(`/mobile/page/pay_password`, qs.stringify(params))
    },
}
export default getOrder;


// WEBPACK FOOTER //
// ./src/assets/js/api/require/order.js